import { SetApiPasswordType } from 'src/app/shared/types/api-instruction.type';

export namespace ApiInstructionAction {
  export class GetDetailInfo {
    static readonly type = '[ApiInstructionAction] GetDetailInfo';
    constructor() {}
  }

  export class ConfigureApiPsw {
    static readonly type = '[ApiInstructionAction] ConfigureApiPsw';
    constructor(public body: SetApiPasswordType) {}
  }
}
